import { TableRow } from "@material-ui/core";
import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";
import React from "react";
import { isBuyGetEnabled } from "../../types/products-table.functions";
import { isWorkOrderEdmTemplate } from "../../../../types/templates/work-order/work-order-template.functions";
import { WORK_ORDER_TEMPLATE } from "../../../../types/templates/work-order/work-order-template.enum";
import { ProductTableRowProps } from "./products-table-row.props";
import { ProductsTablePromoPrice } from "../products-table-promo-price/products-table-promo-price.component";
import { ProductTableBuyGetColumns } from "../products-table-buy-get-columns/products-table-buy-get-columns.component";
import { ProductsTableImageColumn } from "../products-table-image-column/products-table-image-column.component";
import { ProductsTableSkuColumn } from "../products-table-sku-column/products-table-sku-column.component";
import { ProductsTableNameColumn } from "../products-table-name-column/products-table-name-column.component";
import { ProductsTableRegPriceColumn } from "../products-table-reg-price-column/products-table-reg-price-column.component";
import { ProductsTableControlsColumn } from "../products-table-controls-column/products-table-controls-column.component";
import { ProductsTableSavingsBadge } from "../products-table-savings-badge-column/products-table-savings-badge.component";
import { ProductsTablePositionColumn } from "../products-table-position-column/products-table-position-column.component";
import { BuyGetStatus } from "../../../../types/product/ibrief-product/buy-get-status.enum";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";

export const ProductTableRow = withShowIf((props: ProductTableRowProps) => {
  const { product, pageType } = props;
  const fieldPrefix = `products.${props.index}`;
  const buyGetStatusField = `${fieldPrefix}.buyGetStatus`;
  const positionField = `${fieldPrefix}.positionText`;
  const relatedGetsField = `${fieldPrefix}.relatedGetProductIds`;

  const isEdm = () =>
    isWorkOrderEdmTemplate(props.workOrderTemplate as WORK_ORDER_TEMPLATE, pageType);

  const buyGetStatus = () => props.getValues([buyGetStatusField])[0];

  const onRemove = () => props.onRemove(props.index, props.product.id);

  const handleUpdateFuturePrice = (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const formattedValue = event.target.value === "" ? "" : Number(event.target.value).toFixed(2);
    props.setValue(event.target.name, formattedValue);
  };

  const handleUpdatePositionText = (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (event.target.value !== "" && isBuyGetEnabled(props.isBuyGet, pageType)) {
      props.setValue(buyGetStatusField, BuyGetStatus.Buy);
    }
  };

  const handleUpdateBuyGetStatus = (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const status = event.target.value;
    if (Number(status) !== BuyGetStatus.Buy) {
      props.setValue(relatedGetsField, []);
    }

    if (Number(status) === BuyGetStatus.Get) {
      props.setValue(positionField, "");
    } else {
      props.onBuyGetStatusUpdate(props.product.id);
    }

    return props.triggerValidation();
  };

  const isProductActive = () =>
    !Boolean(props.briefEndDatePassed) ? product.productDetail.active : true;

  return (
    <TableRow key={product.productDetail.sku} id={product.productDetail.sku}>
      <ResponsiveTableCell className="small">{product.id}</ResponsiveTableCell>
      <ProductsTableImageColumn product={product} />
      <ProductsTableSkuColumn sku={product.productDetail.sku} active={isProductActive()} />
      <ProductsTableNameColumn name={product.productDetail.name} active={isProductActive()} />

      <ResponsiveTableCell className="wide" align="left">
        {product.productDetail.subcategory}
      </ResponsiveTableCell>

      <ProductTableBuyGetColumns
        errors={props.errors}
        buyGetStatus={buyGetStatus()}
        control={props.control}
        disabled={props.disabled}
        index={props.index}
        onStatusChange={handleUpdateBuyGetStatus}
        onRelatedChange={() => props.triggerValidation()}
        pageType={pageType}
        showIf={isBuyGetEnabled(props.isBuyGet, pageType)}
        template={props.workOrderTemplate}
        workOrderGetProductsList={props.workOrderGetProductsList}
      />

      <ProductsTablePositionColumn
        buyGetStatus={buyGetStatus()}
        control={props.control}
        disabled={props.disabled}
        index={props.index}
        onBlur={handleUpdatePositionText}
        pageType={pageType}
        showIf={isEdm()}
      />

      <ProductsTableRegPriceColumn
        price={product.productDetail.price}
        wasPriceUpdated={product.productDetail.wasPriceUpdated}
      />

      <ProductsTablePromoPrice
        control={props.control}
        disabled={props.disabled}
        index={props.index}
        onBlur={handleUpdateFuturePrice}
        product={product}
      />

      <ProductsTableSavingsBadge
        badge={props.product.badge}
        wasBadgeUpdated={props.product.wasBadgeUpdated}
      />

      <ProductsTableControlsColumn
        disabled={props.disabled}
        onRemoveProduct={onRemove}
        resourceId={product.id}
        resourceType={props.resourceType}
      />
    </TableRow>
  );
});
